import { UITypes } from "types"

import { Pagination } from "components/common/Pagination"
import { ButtonNew } from "components/form/ButtonNew"
import TableWrapper from "components/table/TableWrapper"

import { adHocReportHeaderCells } from "./tableConfig"

import styles from "./index.module.scss"

interface Props {
  rows: UITypes.TableBodyRow[]
  meta?: Parameters<typeof Pagination>[0]["meta"]
  isLoading: boolean
  onExport: () => void
  canExport: boolean
  periodLabel?: string
  averageOnlinePercentage: number | null | undefined
}

export const ReportTable = ({
  rows,
  meta,
  isLoading,
  onExport,
  canExport,
  periodLabel,
  averageOnlinePercentage,
}: Props) => (
  <>
    <div className={styles.reportToolbar}>
      <span className={styles.periodLabel}>Reporting period: {periodLabel}</span>
      <div className={styles.toolbarRight}>
        <div className={styles.averageCard}>
          <div className={styles.averageLabel}>Average online rate</div>
          <div className={styles.averageValue}>{averageOnlinePercentage ?? "N/A"}%</div>
        </div>
        <ButtonNew onClick={onExport} disabled={!canExport}>
          Export
        </ButtonNew>
      </div>
    </div>
    <div className={styles.tableArea}>
      <TableWrapper
        className={styles.tableWrapper}
        headerCells={adHocReportHeaderCells}
        data={rows}
        isLoading={isLoading}
        columnsLoaded
      />
    </div>
    <div className={styles.paginationFooter}>
      <Pagination meta={meta} />
    </div>
  </>
)
